import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {isMimeTypeExists, isNullOrUndefOrEmpty} from "../../../../common";
import {UserService} from "../../../../services/user.service";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {IAppSettingsWrap} from "../../../../interfaces";
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-scene-block-cart',
    templateUrl: './block-cart.component.html',
    styleUrls: ['./block-cart.component.scss']
})
export class BlockCartComponent extends BlockBaseComponent {
    scenesSimple: { name, sceneId }  [];
    assignedScene;
    coreAppData: IAppSettingsWrap;
    constructor(private translocoService: TranslocoService,
                private userService: UserService,
                private router: Router,
                private toastr: ToastrService,
                public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }
    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.storeSelector.getScenes(true).subscribe((i_scenes) => {
                const player = this.storeSelector.getBlockLabelById(this.sceneItem.$.player);
                const mimeTypes = player.types;
                this.scenesSimple = [];

                i_scenes.forEach((scene) => {
                    if (mimeTypes && mimeTypes.length > 0 && !isMimeTypeExists(player.types, scene.Player.$.mimeType)) {
                        return;
                    }
                    const o = {name: scene.Player.$.label, sceneId: scene.Player.$.id};
                    this.scenesSimple.push(o);
                    if (this.sceneItem.Data?.[0]?.Cart?.[0]?.Player[0]?.$?.src == scene.Player.$.id) {
                        this.assignedScene = o;
                    }
                });
            })
        );
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            // {
            //     type: "input",
            //     value: '',
            //     label: this.translocoService.translate('general.label', {}, this.translocoService.getActiveLang()),
            //     inputType: "text",
            //     name: "label",
            //     storePath: 'Data[0].Button[0].$.label'
            // },
            // {
            //     type: "input",
            //     value: '',
            //     label: this.translocoService.translate('general.fieldName', {}, this.translocoService.getActiveLang()),
            //     name: "fieldName",
            //     inputType: "text",
            //     storePath: 'Data[0].Button[0].$.fieldName'
            // }
        ];
    }

    openSceneAssignmentDialog() {
        const player = this.storeSelector.getBlockLabelById(this.sceneItem.$.player);
        const dataDialog: IDialogGetAsset = {mode: "SCENE:MIME", mimeType: player.types[0]};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data: {
                ...dataDialog,
                callBack: (dialogGetAsset) => {
                    dialogRefVal.close();
                    this.onSceneChange({value: {sceneId: dialogGetAsset.selected}});
                }
            }
        });
        this.cod(
            dialogRefVal.afterClosed().pipe(take(1)).subscribe((local) => {
            })
        );
    }

    openSceneEditor() {
        if (isNullOrUndefOrEmpty(this.assignedScene)) return this.toastr.error(this.translocoService.translate('general.notSceneAssigned', {}, this.translocoService.getActiveLang()));
        this.router.navigateByUrl(`/editor/list/${this.assignedScene.sceneId}`);
    }

    onSceneChange(e) {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'src',
                value: e.value.sceneId,
                storePath: `Data[0].Cart[0].Player[0].$`
            }]
        });
    }
}

